"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeProvider = require("../../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FaceBookIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FaceBookIcon, _React$Component);

  function FaceBookIcon() {
    _classCallCheck(this, FaceBookIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(FaceBookIcon).apply(this, arguments));
  }

  _createClass(FaceBookIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          fill = _this$props.fill;
      return _react["default"].createElement("div", {
        className: this.props.theme.faceBookIconCircle
      }, _react["default"].createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 8 18"
      }, _react["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: fill
      }, _react["default"].createElement("g", {
        transform: "translate(-307.000000, -225.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(230.000000, 30.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 68.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(5.000000, 31.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 54.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 29.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(54.000000, 0.000000)"
      }, _react["default"].createElement("path", {
        d: "M19.729145,16.4862 L19.729145,18.96446 L18,18.96446 L18,21.99466 L19.729145,21.99466 L19.729145,30.99978 L23.281243,30.99978 L23.281243,21.99466 L25.664767,21.99466 C25.664767,21.99466 25.888012,20.5415 25.996241,18.9532 L23.29463,18.9532 L23.29463,16.88114 C23.29463,16.57138 23.681907,16.15472 24.064707,16.15472 L26.000014,16.15472 L26.000014,13 L23.368616,13 C19.641332,13 19.729145,16.03322 19.729145,16.4862 Z",
        id: "icon_facebook"
      })))))))))));
    }
  }]);

  return FaceBookIcon;
}(_react["default"].Component);

_defineProperty(FaceBookIcon, "propTypes", {
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  fill: _propTypes["default"].string
});

_defineProperty(FaceBookIcon, "defaultProps", {
  width: '8',
  height: '18',
  fill: '#FFF'
});

var _default = (0, _ThemeProvider.applyTheme)('FaceBookIcon', FaceBookIcon);

exports["default"] = _default;